import { render } from "./edit-business-modal.vue?vue&type=template&id=2135142f&ts=true"
import script from "./edit-business-modal.vue?vue&type=script&lang=ts"
export * from "./edit-business-modal.vue?vue&type=script&lang=ts"

import "./edit-business-modal.vue?vue&type=style&index=0&id=2135142f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__